import React, { useContext } from 'react';
import ClientCard from './clientCard';
import { IPBSClient } from '../../types/common/IPBSClient';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '../ui/button';
import { CurrentUserContext } from '../../context/CurrentUserContext';
import { useWidgets } from '@/context/WidgetContext';

interface ClientListProps {
  clients: IPBSClient[];
}

const ClientList: React.FC<ClientListProps> = ({ clients }) => {
  const { accessControl } = useContext(CurrentUserContext);
  const { widgets, setOpenWidget } = useWidgets();
  const canViewOpenings = accessControl.canRead('widget_openings');
  const canViewServiceRequest = accessControl.canRead('widget_service_request');

  const handleViewOpenings = () => {
    const openingsWidget = widgets.find(w => w.title === 'Openings');
    if (openingsWidget) setOpenWidget(openingsWidget);
  };

  const handleViewServiceRequest = () => {
    const serviceRequestWidget = widgets.find(w => w.title === 'Service Request');
    if (serviceRequestWidget) setOpenWidget(serviceRequestWidget);
  };

  return (
    <Card className="m-2 md:m-8">
      <CardHeader>
        <CardTitle className="text-[14pt]">My Clients</CardTitle>
      </CardHeader>
      <div className="flex flex-wrap">
        {clients.map((client, index) => (
          <div key={index} className="min-w-0">
            <ClientCard client={client} />
          </div>
        ))}
      </div>
      {(canViewOpenings || canViewServiceRequest) && (
        <>
          <CardHeader className="pb-0">
            <CardTitle className="text-[14pt]">Discover New Client Matches</CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <div className="flex items-center gap-2">
              {canViewOpenings && (
                <Button onClick={handleViewOpenings} aria-label="View Openings">
                  View openings
                </Button>
              )}
              {canViewServiceRequest && (
                <Button onClick={handleViewServiceRequest} aria-label="Service Request">
                  Service request
                </Button>
              )}
            </div>
          </CardContent>
        </>
      )}
    </Card>
  );
};

export default ClientList;
